export default __webpack_public_path__ + "static/media/gamestack-list-large.92ecb8d0.jpg";